(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-farmers"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Initialize video controls
  document.querySelectorAll('.play-btn').forEach(playBtn => {
    let videoId = playBtn.dataset.video;
    let video = document.getElementById(videoId);
    let pauseBtn = document.querySelector(`.pause-btn[data-video="${videoId}"]`);

    if (!video || !pauseBtn) return;

    // Play button click
    playBtn.addEventListener('click', function(e) {
      e.preventDefault();
      video.play();
      playBtn.style.display = 'none';
      pauseBtn.style.display = 'flex';
    });

    // Pause button click
    pauseBtn.addEventListener('click', function(e) {
      e.preventDefault();
      video.pause();
      playBtn.style.display = 'flex';
      pauseBtn.style.display = 'none';
    });

    // Reset when video ends
    video.addEventListener('ended', () => {
      playBtn.style.display = 'flex';
      pauseBtn.style.display = 'none';
    });

    // Hide controls when video is playing
    video.addEventListener('play', () => {
      playBtn.style.display = 'none';
      pauseBtn.style.display = 'flex';
    });

    // Show controls when video is paused
    video.addEventListener('pause', () => {
      playBtn.style.display = 'flex';
      pauseBtn.style.display = 'none';
    });
  });

  // Initialize Swiper with delay to ensure DOM is ready
  setTimeout(function() {
    if (typeof Swiper !== 'undefined') {
      const farmersSwiper = new Swiper('.farmers-slider', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 30,
          }
        },
        on: {
          slideChange: function() {
            // Pause all videos when slide changes
            document.querySelectorAll('.farmer-video video').forEach(video => {
              video.pause();
              video.currentTime = 0;
            });
            
            // Reset all play buttons
            document.querySelectorAll('.play-btn').forEach(btn => btn.style.display = 'flex');
            document.querySelectorAll('.pause-btn').forEach(btn => btn.style.display = 'none');
          }
        }
      });
    }
  }, 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".product-tabs__nav button");
  const tabContents = document.querySelectorAll(".product-tabs__content > div");

  tabButtons.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      tabButtons.forEach(b => b.classList.remove("active"));
      tabContents.forEach(c => c.style.display = "none");

      btn.classList.add("active");
      tabContents[index].style.display = "block";
    });
  });

  // Show first tab by default
  if (tabButtons.length > 0) {
    tabButtons[0].classList.add("active");
    tabContents[0].style.display = "block";
  }
});

  } catch(e) { console.error(e); }
})();
})();
